export function MarkdownDisplay({ text }: { text: string }) {
  const lines = text.split("\n");
  return (
    <div className="space-y-0.5 leading-relaxed">
      {lines.map((line, idx) => {
        if (line.startsWith("### ")) return <p key={idx} className="font-semibold text-[11px]">{renderInline(line.slice(4))}</p>;
        if (line.startsWith("## ")) return <p key={idx} className="font-semibold text-[11px]">{renderInline(line.slice(3))}</p>;
        if (line.startsWith("# ")) return <p key={idx} className="font-bold text-[11px]">{renderInline(line.slice(2))}</p>;
        if (line.startsWith("- ")) return <p key={idx} className="pl-2 text-[11px]">• {renderInline(line.slice(2))}</p>;
        if (!line.trim()) return <br key={idx} />;
        return <p key={idx} className="text-[11px]">{renderInline(line)}</p>;
      })}
    </div>
  );
}

function renderInline(content: string) {
  const parts = content.split(/(\*\*.+?\*\*|\*.+?\*|`.+?`)/g);
  return parts.map((part, idx) => {
    if (part.startsWith("**") && part.endsWith("**"))
      return <strong key={idx}>{part.slice(2, -2)}</strong>;
    if (part.startsWith("*") && part.endsWith("*"))
      return <em key={idx}>{part.slice(1, -1)}</em>;
    if (part.startsWith("`") && part.endsWith("`"))
      return <code key={idx} className="rounded bg-background px-1 font-mono text-[10px]">{part.slice(1, -1)}</code>;
    return <span key={idx}>{part}</span>;
  });
}
